import Base from './Base'
import Html from './Html'
import Markdown from './Markdown'

export const mapStepToComponent = {
  Base,
  Markdown,
  Html
}

export const stepComponent = (resource='Base') => {
  return mapStepToComponent[resource]
}


// WEBPACK FOOTER //
// ./components/Service_Steps/Info/index.jsx